import { DataGrid, GridSortModel } from "@mui/x-data-grid";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { FontRoboto, v2theme } from "../../../../../styles/Theme";

const useStyles = makeStyles<Theme, FeedbackTableViewProps>((theme) => ({
  dataTable: {
    borderRadius: "8px",
    border: (props) => `${props.border ? "2px" : "0px"} solid ${theme.palette.divider}`,
    backgroundColor: "white",
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      flexDirection: "row !important",
      fontWeight: theme.typography.fontWeightBold,
    },
    "& .MuiDataGrid-iconButtonContainer": {
      marginLeft: "auto",
    },
    "& .MuiDataGrid-columnHeaders": {
      height: "50px",
      minHeight: "unset",
      borderBottom: `2px solid ${theme.palette.divider}`,
      // border: "3px solid #E8E8E8 !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontFamily: FontRoboto,
      fontSize: "1em",
      fontWeight: theme.typography.fontWeightBold,
    },
    "& .MuiDataGrid-columnHeader": {
      "&:focus, &:focus-within": {
        outline: "none",
      },
      "&:hover": {
        color: theme.palette.primary.main,
      },
      "& .MuiDataGrid-sortIcon": {
        color: theme.palette.primary.main,
      },
    },
    "& .MuiDataGrid-columnHeader--sorted": {
      color: theme.palette.primary.main,
      "& .MuiDataGrid-sortIcon": {
        color: theme.palette.primary.main,
      },
    },
    "& .MuiDataGrid-cell": {
      border: "0px",
      "&:focus, &:focus-within": {
        outline: "none",
      },
    },
    "& .MuiDataGrid-cellContent": {
      fontFamily: FontRoboto,
      fontSize: "1em",
      fontWeight: v2theme.typography.fontWeightRegular,
      color: v2theme.palette.text.secondary,
    },
  },
  dataTableHeaderWithBorder: {
    borderRight: `2px solid ${theme.palette.divider}`,
    "& > .MuiDataGrid-columnSeparator": {
      visibility: "hidden",
    },
  },
  dataTableCellWithBorder: {
    fontWeight: theme.typography.fontWeightMedium,
    borderRight: `2px solid ${theme.palette.divider} !important`,
  },
  dataTableHeader: {
    "& > .MuiDataGrid-columnSeparator": {
      visibility: "hidden",
    },
  },
  sortedDataTableValue: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.primary.main,
  },
}));
interface FeedbackTableViewProps {
  rows: any;
  columns: any;
  loading: boolean;
  onSortModelChange?: (model: GridSortModel) => void;
  border?: boolean;
}

export const FeedbackTableView = (props: FeedbackTableViewProps) => {
  const classes = useStyles(props);
  const { rows, columns, loading, onSortModelChange } = props;
  return (
    <DataGrid
      getRowId={(row: any) => row.questionId || row.id}
      className={classes.dataTable}
      columns={columns}
      rows={rows}
      onSortModelChange={onSortModelChange}
      autoHeight
      disableSelectionOnClick
      disableColumnSelector
      disableDensitySelector
      disableColumnMenu
      hideFooter
      loading={loading}
    />
  );
};
